import { render, staticRenderFns } from "./ProfileAccountUpdate.vue?vue&type=template&id=857bc4f4&"
import script from "./ProfileAccountUpdate.vue?vue&type=script&lang=js&"
export * from "./ProfileAccountUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAccountUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports